import React, { useEffect } from 'react';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => {
    useEffect(() => {
        document.body.classList.add('bg-body');
        return () => {
            document.body.classList.remove('bg-body');
        };
    }, []);

    return (
        <div
            className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
            style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/bg_login.png')})`,
            }}
        >
            {/* begin::Content */}
            <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
                {/* begin::Logo */}
                <a href="#" className="mb-12">
                    <img alt="Logo" src={toAbsoluteUrl('/media/logos/logo_digitent.png')} className="h-45px" />
                </a>
                {/* end::Logo */}
                {/* begin::Wrapper */}
                <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
                    <Outlet />
                </div>
                {/* end::Wrapper */}
            </div>
            {/* end::Content */}
            {/* begin::Footer */}
            <div className="d-flex flex-center flex-column-auto p-10">
                <div className="d-flex align-items-center fw-bold fs-6">
                    <a href="https://app.digitent.co" className="text-muted text-hover-primary px-2">
                        About
                    </a>

                    <a href="mailto:support@digitent.co" className="text-muted text-hover-primary px-2">
                        Support
                    </a>
                </div>
            </div>
            {/* end::Footer */}
        </div>
    );
};

export default AuthLayout;
